import { render, staticRenderFns } from "./license.vue?vue&type=template&id=39191c2a&scoped=true&"
import script from "./license.vue?vue&type=script&lang=js&"
export * from "./license.vue?vue&type=script&lang=js&"
import style0 from "./license.vue?vue&type=style&index=0&id=39191c2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39191c2a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AboutTabs: require('/opt/render/project/src/channels2022/src/components/about/AboutTabs.vue').default})
